console.log('Did you seriously think this website had javascript;');
